__turbopack_context__.v({
  "avatar": "Navbar-module-scss-module__fhFYKq__avatar",
  "badge": "Navbar-module-scss-module__fhFYKq__badge",
  "fade-in": "Navbar-module-scss-module__fhFYKq__fade-in",
  "flash": "Navbar-module-scss-module__fhFYKq__flash",
  "hover": "Navbar-module-scss-module__fhFYKq__hover",
  "loaded": "Navbar-module-scss-module__fhFYKq__loaded",
  "logo": "Navbar-module-scss-module__fhFYKq__logo",
  "logoSmall": "Navbar-module-scss-module__fhFYKq__logoSmall",
  "menu": "Navbar-module-scss-module__fhFYKq__menu",
  "navbar": "Navbar-module-scss-module__fhFYKq__navbar",
  "navbarColor": "Navbar-module-scss-module__fhFYKq__navbarColor",
  "positive": "Navbar-module-scss-module__fhFYKq__positive",
  "reveal": "Navbar-module-scss-module__fhFYKq__reveal",
  "special": "Navbar-module-scss-module__fhFYKq__special",
});
